import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './auth/config.service';
import { Router } from '@angular/router';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient, private configService: ConfigService, private router: Router) { }

  GetBlock(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/GetBlock`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  GetTargetCount(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/GetTargetCount`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  getCircle() {
    const apiUrl = `${this.configService.getApiUrl()}/Report/GetCircle`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  getTargetDetail(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/GetTargetDetail`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  addTarget(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/AddTarget`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  // Get Arbitration Cases


  getArbitrationCases(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/GetArbitrationCases`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  AddChallan(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/AddChallan`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  getAuditFeeRecoveryData(data: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Report/GetAuditFeeeRecoveryData`;
    return this.http.post<any>(apiUrl, data);
  }
  getAuditFeeeRecoveryDetail(data: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Report/GetAuditFeeeRecoveryDetail`;
    return this.http.post<any>(apiUrl, data);
  }
  getChallanDetail(data: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Report/GetChallan`;
    return this.http.post<any>(apiUrl, data);
  }

  deleteChallan(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteChallan/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  AddArbitrationCases(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/AddArbitrationCases`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  DeleteArbitrationData(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteArbitrationData/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

getSocieties(itypeid: number): Observable<any> {
  return this.http.post<any>(
    `${this.configService.getApiUrl()}/Report/GetSocietiesTypeWise`,
    {},
    { params: { itypeid } }
  );
}

  GetMisutiliztionDropdown(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetMisutiliztionDropdown`, payload);
  }
  GetYearAndMonth(payload: any): Observable<any[]> {
    return this.http.get<any[]>(`${this.configService.getApiUrl()}/Report/GetYearAndMonth`);
  }
  GetMisutilizationData(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetMisutilization`, payload);
  }
  addMisutilizationData(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddMisutilization`, payload);
  }
  DeleteMisutilization(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteMisutilization/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  VerifyMisutilization(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyMisutilization/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  //      DeleteConsumerData(CaseDataId:any) {
  //   const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteConsumerData/${CaseDataId}`;
  //   return this.http.post<any>(apiUrl,{}).pipe(
  //     map((response) => {
  //       return response;
  //     }),
  //     catchError((err) => {
  //       console.error('API Error: ', err);
  //       return throwError(() => new Error('Target retrieval failed.'));
  //     })
  //   );
  // }
  //   verifyConsumerData(CaseDataId:any) {
  //   const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyConsumerData/${CaseDataId}`;
  //   return this.http.post<any>(apiUrl,{}).pipe(
  //     map((response) => {
  //       return response;
  //     }),
  //     catchError((err) => {
  //       console.error('API Error: ', err);
  //       return throwError(() => new Error('Target retrieval failed.'));
  //     })
  //   );
  // }
  GetConsumerGoods(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetConsumerGoods`, payload);
  }
  addConsumerGoods(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/addConsumerGoods`, payload);
  }

  DeleteConsumerData(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteConsumerData/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  verifyConsumerData(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyConsumerData/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  GetElection(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetTElectionConducted`, payload);
  }
  AddElection(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddTElectionConducted`, payload);
  }
  DeleteElectionData(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteElectionData/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  verifyElectionData(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyElectionData/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  GetExecution(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetTExecutionCases`, payload);
  }
  AddExecution(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddTExecutionCases`, payload);
  }
  DeleteExecutionData(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteTExecutionCases/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyExecutionData(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifiedTExecutionCases/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  VerifyArbitrationData(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyArbitrationData/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }


  GetSocietyAndLiquidationData(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetSocietyAndLiquidationData`, payload);
  }
  AddSocietyLiquidationDetail(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddSocietyLiquidationDetail`, payload);
  }


  DeleteSocietyAndLiquidation(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteSocietyAndLiquidation/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifySocietyAndLiquidation(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifiedSocietyAndLiquidation/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  GetTFPSInspectionDetails(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetTFPSInspectionDetails`, payload);
  }
  AddTFPSInspectionDetails(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddTFPSInspectionDetails`, payload);
  }


  DeleteFPSInspectionDetails(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteTFPSInspectionDetails/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyFPSInspectionDetails(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifiedTFPSInspectionDetails/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  GetFertilizerDepotInspection(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetFertilizerDepotInspection`, payload);
  }
  AddFertilizerDepotInspection(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddFertilizerDepotInspection`, payload);
  }


  DeleteGetFertilizerDepot(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteFertilizerDepotInspection/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyGetFertilizerDepot(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifiedFertilizerDepotInspection/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  GetMisappropriation(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetMisappropriation`, payload);
  }
  AddMisappropriation(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddMisappropriation`, payload);
  }


  DeleteMisappropriation(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteMisappropriation/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyMisappropriation(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifiedMisappropriation/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  GetPDSStockLifting(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetPDSStockLifting`, payload);
  }
  AddPDSStockLifting(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddPDSStockLifting`, payload);
  }


  DeletePDSStockLifting(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeletePDSStockLifting/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyPDSStockLifting(CaseDataId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifiedPDSStockLifting/${CaseDataId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  getFertilizerTypes(): Observable<any[]> {
    return this.http.get<any[]>(`${this.configService.getApiUrl()}/Report/GetFertilizerTypes`);
  }
  GetTFertilizerSalePurchase(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetTFertilizerSalePurchase`, payload);
  }
  AddTFertilizerSalePurchase(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddTFertilizerSalePurchase`, payload);
  }


  DeleteTFertilizerSalePurchase(payload: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteTFertilizerSalePurchase`;
    return this.http.post<any>(apiUrl, payload).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyFertilizerSalePurchase(payload: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyTFertilizerSalePurchase`;
    return this.http.post<any>(apiUrl, payload).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  GetMisutilizationReport(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetMisutilizationReport`, payload);
  }
  addMisutilizationReport(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddMisutilizationReport`, payload);
  }


  DeleteMisutilizationReport(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteMisutilizationReport/${id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyMisutilizationReport(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyMisutilizationReport/${id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }
  GetInspectionCSTarget(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetInspectionCSTarget`, payload);
  }
  addInspectionCSTarget(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddInspectionCSTarget`, payload);
  }


  DeleteInspectionCSTarget(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteInspectionCSTarget/${id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyInspectionCSTarget(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyInspectionCSTarget/${id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }


  getAuditSocieties(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetSocieties`, payload);
  }
  AddAuditFeeRecovery(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/AddAuditFeeRecovery`, payload);
  }


  deleteAuditFeeRecovery(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteAuditFeeRecovery/${id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyAuditFeeRecovery(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyAuditFeeRecovery/${id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  addAuditCounducted(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/AddAuditConducted`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  getAuditCounducted(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetAuditConducted`, payload);
  }

  verifyaAuditConducted(Id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyAuditConducted/${Id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  DeleteAuditConducted(Id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteAuditConducted/${Id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  addAuditFeesMPR(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/AddAuditFeesMPR`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  getAuditFeesMPR(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetAuditFeesMPR`, payload);
  }

  verifyaAuditFeesMPR(Id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyAuditFeesMPR/${Id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  DeleteAuditFeesMPR(Id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteAuditFeesMPR/${Id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  getProgressDetail(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetProgressDevelopment`, payload);
  }

  getSocietyType(): Observable<any[]> {
    return this.http.post<any[]>(
      `${this.configService.getApiUrl()}/Report/GetSocietyType`,
      {} // empty body (required for POST)
    );
  }


  addInvestment(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/AddInvestment`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  getInvestmentData(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetInvestment`, payload);
  }

  deleteinvestment(Id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteInvestment/${Id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  addProgressDevelopmentData(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/AddProgressDevelopment`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyaProgressDevelopment(Id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyProgressDevelopment/${Id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  deleteProgressDevelopment(Id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteProgressDevelopment/${Id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  getTribalDdata(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetTribal`, payload);
  }

  addDevelopmentExpenditure(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/AddDevelopmentBudgetExpenditure`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }


  getExpenditureDetail(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.configService.getApiUrl()}/Report/GetDevelopmentBudgetExpenditure`, payload);
  }

  verifyaDevelopmentExpenditure(Id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyDevelopmentBudgetExpenditure/${Id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  deleteDevelopmentExpenditure(Id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteDevelopmentBudgetExpenditure/${Id}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  deleteAuditFeesMPR(payload: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/DeleteAuditFeesMPR`;
    return this.http.post<any>(apiUrl, payload).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

  verifyAuditFeesMPR(payload: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Report/VerifyAuditFeesMPR`;
    return this.http.post<any>(apiUrl, payload).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        console.error('API Error: ', err);
        return throwError(() => new Error('Target retrieval failed.'));
      })
    );
  }

    getHeadData(): Observable<any[]> {
    return this.http.get<any[]>(`${this.configService.getApiUrl()}/Report/GetAccountHead`);
  }
}
